module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fontinfo effect1",
    style: (_vm.getStyle),
    attrs: {
      "id": "reservationPopup"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("予約")]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "reservationForm"
    },
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "mouseup": function($event) {
        $event.stopPropagation();
      },
      "mousemove": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('table', {
    class: {
      errorDuplication: _vm.isSomeDuplicatedReservation
    },
    attrs: {
      "title": _vm.isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : ''
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.previewBox.start),
      expression: "$store.state.previewBox.start"
    }],
    staticClass: "time_Selector",
    attrs: {
      "type": "time",
      "min": "10:00",
      "max": "23:00"
    },
    domProps: {
      "value": (_vm.$store.state.previewBox.start)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.previewBox, "start", $event.target.value)
      }
    }
  })]), _vm._v("〜\n      "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.previewBox.end),
      expression: "$store.state.previewBox.end"
    }],
    staticClass: "time_Selector",
    attrs: {
      "type": "time",
      "min": "10:00",
      "max": "23:00"
    },
    domProps: {
      "value": (_vm.$store.state.previewBox.end)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.previewBox, "end", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', [(_vm.$store.state.userInfo.user_type === 'student') ? _c('div', [_c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("通常")]), _vm._v(" "), _c('option', [_vm._v("通常初回")]), _vm._v(" "), _c('option', [_vm._v("短期")])]), _vm._v("\n      授業\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher' || _vm.$store.state.userInfo.user_type === 'admin') ? _c('div', [_c('label', {
    attrs: {
      "id": "reservationType"
    }
  }, [_vm._v("授業の種類：\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("通常")]), _vm._v(" "), _c('option', [_vm._v("通常初回")]), _vm._v(" "), _c('option', [_vm._v("体験")]), _vm._v(" "), _c('option', [_vm._v("短期")]), _vm._v(" "), _c('option', [_vm._v("短期初回")])]), _vm._v("\n      授業\n    ")])]) : _vm._e()]), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("生徒のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'student') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('autocomplete', {
    attrs: {
      "type": 'student',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getStudentList(),
      "placeholder": '生徒のお名前'
    },
    model: {
      value: (_vm.student),
      callback: function($$v) {
        _vm.student = $$v
      },
      expression: "student"
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "nameinput"
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e(), _vm._v(" "), (!_vm.isTanki) ? [_c('div', {
    staticClass: "nameinput",
    staticStyle: {
      "margin-top": "13px"
    }
  }, [_c('label', {
    attrs: {
      "id": "hasTest"
    }
  }, [_vm._v("配布物（確認テスト等）: "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasTest),
      expression: "hasTest"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hasTest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n          有り\n        ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n          無し\n        ")])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isOnline),
      expression: "isOnline"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isOnline) ? _vm._i(_vm.isOnline, null) > -1 : (_vm.isOnline)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isOnline,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isOnline = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isOnline = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isOnline = $$c
        }
      }
    }
  }), _vm._v(" オンライン授業"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message_area",
    staticStyle: {
      "width": "50vw"
    },
    attrs: {
      "id": "message",
      "placeholder": "連絡事項"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.type == '通常' || '短期') ? _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRecurrent),
      expression: "isRecurrent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRecurrent) ? _vm._i(_vm.isRecurrent, null) > -1 : (_vm.isRecurrent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isRecurrent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRecurrent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRecurrent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRecurrent = $$c
        }
      }
    }
  }), _vm._v("月末まで毎週予約する")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ender"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "予約をする",
      "disabled": !_vm.canTakeResv
    },
    on: {
      "click": _vm.takeReservation
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "キャンセル"
    },
    on: {
      "click": _vm.closePopup
    }
  })]), _vm._v(" "), (_vm.isRecurrent) ? _c('recurrent-panel') : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isTanki) ? [_c('temporaryLecturePanel', {
    attrs: {
      "teacher": _vm.teacher,
      "reservationType": _vm.type
    }
  }, [_c('span', [_vm._v("先生のお名前：")]), _vm._v(" "), (_vm.$store.state.userInfo.user_type === 'teacher') ? [_c('input', {
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.$store.state.userInfo.fullname
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "hidden": ""
    },
    domProps: {
      "value": _vm.setHiddenID()
    }
  })] : (_vm.$store.state.userInfo.user_type === 'student') ? [_c('autocomplete', {
    attrs: {
      "type": 'teacher',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })] : [_c('autocomplete', {
    attrs: {
      "type": 'admin',
      "suggestions": _vm.getTeacherList(),
      "placeholder": '先生のお名前'
    },
    model: {
      value: (_vm.teacher),
      callback: function($$v) {
        _vm.teacher = $$v
      },
      expression: "teacher"
    }
  })]], 2)] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("時間: ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9f9fc18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/timetable/boxes/SpReservationPopup.vue
// module id = 736
// module chunks = 0